import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../contexts/AuthContext';

const ConfirmationModal = ({ setConfirmationModal, onSuccess, onCancel }) => {
  const { t } = useTranslation('login');
  const { logout } = useAuth();

  const handleConfirm = async () => {
    await logout();
  };
  const handleCancel = async () => {
    setConfirmationModal(false);
  };
  return (
    <div className="modal fade show d-block add-new-fbz" id="add-order-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">{t('CONFIRMATION')}</h1>
            <button
              type="button"
              className="btn-close"
              onClick={() => setConfirmationModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            <h3>{t('LOGOUTCONFIRMATION')}</h3>
            {/* Bottom buttons */}
            <div className="bottom-button">
              <button className="cancel" onClick={() => handleCancel()}>
                {t('CANCEL')}
              </button>
              <button className="save" onClick={() => handleConfirm()}>
                {t('CONFIRM')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ConfirmationModal;
